// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1265":"548c1e2f","1280":"fe6f8f74","2572":"5f614f2a","4424":"e7eb9df8","7817":"d0728ee5","7929":"d09b2f7a"}[chunkId] + ".chunk.css";
};